import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { axiosInstance } from '../apis';
import { CustomerMeResponse, LoginResponseDto } from '../apis/client-axios';
import { USER_ROUTE_PATH } from '../constants/router';

export interface AuthState {
  loading: boolean;
  error: string;
  userType?: 'administrator' | 'customer';
  authUser?: CustomerMeResponse;
  isFirstLogin?: boolean;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: (): AuthState => {
    let initState: AuthState = {
      loading: false,
      error: '',
    };

    const authUser = localStorage.getItem('authUser');
    if (authUser) {
      initState.authUser = JSON.parse(authUser);
    }

    return initState;
  },
  reducers: {
    updateIsFistLogin: (state, action: PayloadAction<boolean>) => {
      state.isFirstLogin = action.payload;
    },
    login: (state, action: PayloadAction<LoginResponseDto>) => {
      localStorage.setItem('authUser', JSON.stringify(action.payload));
      localStorage.setItem('token', action.payload.token);
      axiosInstance.defaults.headers.Authorization = action.payload.token ? `Bearer ${action.payload.token}` : '';
    },
    updateMe: (state, action: PayloadAction<CustomerMeResponse>) => {
      state.authUser = action.payload;
    },
    logout: (state) => {
      state.authUser = undefined;
      state.isFirstLogin = undefined;
      localStorage.clear();
      window.location.href = USER_ROUTE_PATH.HOME;
      //  sessionStorage.clear();
    },
  },
});

export const { logout, login, updateMe, updateIsFistLogin } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
